<template>
  <textarea
    :placeholder="placeholder"
    :disabled="disabled"
    @focus="resize"
    :value="value"
    :style="computedStyles"
    @keyup.enter.exact="onKeyEnter"
    @keyup="onKeyUp"
    @click="onClick"
    @input="input"
  ></textarea>
</template>
<script>
export default {
  name: "TextareaAutosize",
  mounted() {
    this.resize();
  },
  props: {
    onEnter: {
      required: false
    },
    value: {
      type: String,
      default: ""
    },
    autosize: {
      type: Boolean,
      default: true
    },
    minHeight: {
      type: [Number],
      default: null
    },
    maxHeight: {
      type: [Number],
      default: null
    },
    important: {
      type: [Boolean, Array],
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    placeholder: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      textareaValue: null,
      maxHeightScroll: false
    };
  },
  computed: {
    computedStyles() {
      let objStyles = {};
      if (this.autosize) {
        objStyles.resize = !this.isResizeImportant ? "none" : "none !important";
        if (!this.maxHeightScroll) {
          objStyles.overflow = !this.isOverflowImportant
            ? "hidden"
            : "hidden !important";
        }
      }
      return objStyles;
    },
    isResizeImportant() {
      const imp = this.important;
      return imp === true || (Array.isArray(imp) && imp.includes("resize"));
    },
    isOverflowImportant() {
      const imp = this.important;
      return imp === true || (Array.isArray(imp) && imp.includes("overflow"));
    },
    isHeightImportant() {
      const imp = this.important;
      return imp === true || (Array.isArray(imp) && imp.includes("height"));
    }
  },
  methods: {
    onKeyUp(e) {
      this.$emit("keyup", e);
    },
    onClick(e) {
      this.$emit("click", e);
    },
    onKeyEnter(e) {
      e.stopPropagation();
      e.preventDefault();
      e.returnValue = false;
      if (this.onEnter) this.onEnter();
    },
    resize: function() {
      const important = this.isHeightImportant ? "important" : "";
      this.$el.style.setProperty("height", "auto", important);
      let contentHeight = this.$el.scrollHeight + 1;
      if (this.minHeight) {
        contentHeight =
          contentHeight < this.minHeight ? this.minHeight : contentHeight;
      }
      if (this.maxHeight) {
        if (contentHeight > this.maxHeight) {
          contentHeight = this.maxHeight;
          this.maxHeightScroll = true;
        } else {
          this.maxHeightScroll = false;
        }
      }
      const heightVal = contentHeight + "px";
      this.$el.style.setProperty("height", heightVal, important);
      return this;
    },
    input(event) {
      if (
        Laravel.user.roles.some(el => el.name === "moderator") &&
        event.inputType == "insertFromPaste"
      ) {
        event.target.value = this.value;
      }
      this.$emit("input", event.target.value);
    }
  },
  watch: {
    value() {
      this.$nextTick(this.resize);
    }
  }
};
</script>
